import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

export default function PublicGuard({ children }) {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/admin/dashboard" />;
  }

  return <>{children}</>;
}
